import { Box, Paper, Stack, Step, StepLabel, Stepper, styled, Typography } from '@mui/material';
import React from 'react';
import { datetimeFormatter } from '../../../utils/datetimeFormatter';
import { TimerOutlined } from '@mui/icons-material';
import { WorkflowBreadCrumbs } from '../../WorkflowBreadCrumbs';

const CustomPaper = styled(Paper)({
  padding: '30px',
});

const CommonUpperSection = ({ leadTimeLines, leadDetails, workflowStatusByPipeLine }) => {
  const getLeadTimelineTemplate = () => {
    return leadTimeLines?.length > 0 ? (
      <Box sx={{ width: '100%' }}>
        <Stepper id="timeline-stepper" alternativeLabel>
          {leadTimeLines.map((label, index) => (
            <Step active={!label.isSubStatus} key={index}>
              <StepLabel
                StepIconProps={{
                  style: {
                    color: '#1976d2',
                  },
                }}
              >
                <span className="text-sm">{label.workflowName}</span>
                <br />
                <span className="text-sm">{label.actionDate}</span>
                <br />
                <span className="text-sm">{label.actionBy}</span>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    ) : (
      <Typography
        sx={{
          fontWeight: '400',
          alignSelf: 'center',
          fontSize: '12px',
          textAlign: 'center',
          p: '15px',
        }}
        component="p"
      >
        No timelines
      </Typography>
    );
  };

  return (
    <>
      {/* Common: Stepper Section */}
      <CustomPaper>{getLeadTimelineTemplate()}</CustomPaper>
      {/* Common: Lead Graphical View */}
      <CustomPaper>
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Stack direction={'column'}>
            <Typography sx={{ fontSize: '12px', fontWeight: '700', alignSelf: 'start' }} component="p">
              START
            </Typography>
            <Typography sx={{ fontSize: '12px', fontWeight: '500', alignSelf: 'center' }} component="p">
              {leadDetails.leadDate
                ? datetimeFormatter.formatDate(leadDetails.leadDate, datetimeFormatter.toLocal)
                : ''}
            </Typography>
          </Stack>
          <Stack direction={'column'}>
            <Typography sx={{ fontSize: '12px', fontWeight: '700', alignSelf: 'end' }} component="p">
              CLOSING
            </Typography>
            <Stack
              direction={'row'}
              alignItems={'center'}
              sx={{ fontSize: '12px', fontWeight: '500', alignSelf: 'center' }}
              component="p"
            >
              <span>
                {leadDetails.closeDate
                  ? datetimeFormatter.formatDate(leadDetails.closeDate, datetimeFormatter.toLocal)
                  : ''}
              </span>
              <TimerOutlined color="success" sx={{ fontSize: '13px', marginLeft: '2px' }}></TimerOutlined>
            </Stack>
          </Stack>
        </Stack>
        <Stack sx={{ mt: '20px' }}>
          <WorkflowBreadCrumbs
            currentWorkflowId={leadDetails.currentWorkflowId}
            workflowStatusByPipeLine={workflowStatusByPipeLine}
          ></WorkflowBreadCrumbs>
        </Stack>
      </CustomPaper>
    </>
  );
};

export default CommonUpperSection;
